import { render, staticRenderFns } from "./SocialsSpinner.vue?vue&type=template&id=702f5277&scoped=true&"
import script from "./SocialsSpinner.vue?vue&type=script&lang=js&"
export * from "./SocialsSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SocialsSpinner.vue?vue&type=style&index=0&id=702f5277&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f5277",
  null
  
)

export default component.exports